module.exports = __webpack_public_path__ + "img/incubator-2.3c78800f.webp";